import { FiMoon, FiSun } from "react-icons/fi";
import { useTema } from "../utils/tema";

export default function ThemeToggle() {
  const [tema, cambiarTema] = useTema();
  const oscuro = tema === "dark";
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={cambiarTema}
      aria-label={oscuro ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      title={oscuro ? "Modo claro" : "Modo oscuro"}
    >
      {oscuro ? <FiSun /> : <FiMoon />}
    </button>
  );
}
